import script from "./ProductDetailEN.vue?vue&type=script&setup=true&name=ProductDetailEN&lang=js"
export * from "./ProductDetailEN.vue?vue&type=script&setup=true&name=ProductDetailEN&lang=js"

import "./ProductDetailEN.vue?vue&type=style&index=0&id=9a8c455e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a8c455e"]])

export default __exports__